import { render, staticRenderFns } from "./button.vue?vue&type=template&id=13eb8769&"
import script from "./button.vue?vue&type=script&lang=js&"
export * from "./button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "button.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/base/button/button.vue
// module id = 105
// module chunks = 0